import AppRouter from "./Router";

/**
 * The App component is the main component of the application.
 * It handles authentication, user redirection and renders the Router component.
 */
const App = () => {
  return <AppRouter />;
};

export default App;
